// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1b7yS","right":"styles_right__2ZtgJ"};